// Pedizone'un yer aldığı resmi pazaryerleri
export const marketplaces = [
  {
    id: 'trendyol',
    name: 'Trendyol',
    logo: '/marketplaces/trendyol.png',
    url: 'https://www.trendyol.com/sr?mid=1114633&id=949004162%2C974106929%2C974407501%2C993719944&os=1',
    accent: '#F27A1A',
    tint: 'rgba(242,122,26,0.10)',
    logoClass: 'max-h-[78px] w-auto max-w-[85%] object-contain',
  },
  {
    id: 'hepsiburada',
    name: 'Hepsiburada',
    logo: '/marketplaces/hepsiburada.svg',
    url: 'https://www.hepsiburada.com/magaza/medipodo?tab=allproducts',
    accent: '#FF6000',
    tint: 'rgba(255,96,0,0.10)',
  },
  {
    id: 'amazon',
    name: 'Amazon',
    logo: '/marketplaces/amazon.svg',
    url: 'https://www.amazon.com.tr/s?me=AMMP0XZD7GV7U&marketplaceID=A33AVAJ2PDY3EV',
    accent: '#FF9900',
    tint: 'rgba(255,153,0,0.10)',
  },
];

export const trustBadges = [
  { icon: 'ShieldCheck', label: 'Resmi Mağaza' },
  { icon: 'Truck', label: 'Hızlı Kargo' },
  { icon: 'Lock', label: 'Güvenli Ödeme' },
];
